export function formatSchoolName(name) {
	if (!name || typeof name !== 'string') {
		return name || '';
	}
	return name
		.replace(/\\"/g, '"')
		.replace(/\\\\/g, '')
		.replace(/\\r\\n|\\r|\\n/g, ' ')
		.replace(/\r\n|\r|\n/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
}

export function formatSchoolList(schools) {
	if (!Array.isArray(schools)) {
		return [];
	}
	return schools.map((school) => ({
		...school,
		name: formatSchoolName(school.name),
	}));
}
